import { useMemo } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '@redux/store'
import generateRoutes, { fallbackRoutes } from '../router'

/** Tiêu đề trang hiện tại (từ route.title) — dùng trên header như logistics. */
export const useCurrentRouteTitle = (): string => {
  const { pathname } = useLocation()
  const { webChucNangAll } = useSelector((state: RootState) => state.menu)

  const routes = useMemo(() => {
    if (webChucNangAll && webChucNangAll.length > 0) {
      try {
        return generateRoutes(webChucNangAll)
      } catch {
        return fallbackRoutes
      }
    }
    return fallbackRoutes
  }, [webChucNangAll])

  return useMemo(() => {
    let bestTitle = ''
    let bestScore = -1

    for (const route of routes) {
      if (!route?.path || !route?.title) continue
      const match = matchPath(pathname, {
        path: route.path,
        exact: route.exact !== false,
        strict: false,
      })
      if (!match) continue
      const score = String(route.path).length
      if (score > bestScore) {
        bestScore = score
        bestTitle = route.title
      }
    }

    if (!bestTitle) return ''
    // Title trong router thường UPPERCASE — hiển thị câu thường dễ đọc
    const lower = bestTitle.toLowerCase()
    return lower.charAt(0).toUpperCase() + lower.slice(1)
  }, [pathname, routes])
}
